import gsap from "gsap/gsap-core";
import {
  Mesh,
  SphereBufferGeometry,
  BackSide,
  ShaderMaterial,
  Color,
  Vector4,
} from "three";
import content from "../../data/content";
import curation from "../../data/curation";
import { vertexShader, fragmentShader } from "./shader.glsl";

export default class Background {
  constructor(gui) {
    this.gui = gui.addFolder("background");
    this.gui.open();

    this.config = {
      gradientX: content[curation.id].colors[0],
      gradientY: content[curation.id].colors[1],
      gradientZ: content[curation.id].colors[2],
    };

    const material = new ShaderMaterial({
      uniforms: {
        time: {
          value: 0,
        },
        iridescentSpeed: {
          value: 0.95,
        },
        gradientX: {
          value: new Color(this.config.gradientX),
        },
        gradientY: {
          value: new Color(this.config.gradientY),
        },
        gradientZ: {
          value: new Color(this.config.gradientZ),
        },
        iridescentVal: {
          value: new Vector4(0.4, 22, 2, 1.97),
        },
        iridescentVal2: {
          value: new Vector4(6.5, 2.7),
        },
        transition: {
          value: 0,
        },
      },
      wireframe: false,
      vertexShader,
      fragmentShader,
      side: BackSide,
    });

    this.gui
      .add(material.uniforms.iridescentSpeed, "value", 0, 2)
      .name("iridescentSpeed");
    this.gui.addColor(this.config, "gradientX").onChange((val) => {
      material.uniforms.gradientX.value.setStyle(val);
    });
    this.gui.addColor(this.config, "gradientY").onChange((val) => {
      material.uniforms.gradientY.value.setStyle(val);
    });
    this.gui.addColor(this.config, "gradientZ").onChange((val) => {
      material.uniforms.gradientZ.value.setStyle(val);
    });
    this.gui.add(material.uniforms.iridescentVal.value, "x", 0, 30);
    this.gui.add(material.uniforms.iridescentVal.value, "y", 0, 30);
    this.gui.add(material.uniforms.iridescentVal.value, "z", 0, 30);
    this.gui.add(material.uniforms.iridescentVal.value, "w", 0, 30);
    this.gui.add(material.uniforms.iridescentVal2.value, "x", 0, 1);
    this.gui.add(material.uniforms.iridescentVal2.value, "y", 0, 30);

    const geometry = new SphereBufferGeometry(100, 32, 32);

    this.mesh = new Mesh(geometry, material);
    this.mesh.matrixAutoUpdate = false;
    this.mesh.updateMatrix();
    this.mesh2 = new Mesh(geometry, material);
    this.mesh2.matrixAutoUpdate = false;
    this.mesh2.updateMatrix();
  }

  animate() {
    gsap.to(this.mesh.material.uniforms.transition, 2, {
      value: 1,
    });
  }

  update(delta) {
    this.mesh.material.uniforms.time.value += delta;
  }
}
